import {isMurphyCustomer} from 'common/constants/organizations';

export interface ComplianceOverrideOption {
    value: string;
    label: string;
}

export interface ComplianceOverrideFieldConfiguration {
    overriderTitles: ComplianceOverrideOption[];
    trainingOverrides: ComplianceOverrideOption[];
    trainingOverrideLabel: string;
}

const DEFAULT_OVERRIDER_TITLES: ComplianceOverrideOption[] = [
    {value: 'OIM', label: 'OIM'},
    {value: 'CLERK', label: 'Clerk'}
];

const DEFAULT_TRAINING_OVERRIDES: ComplianceOverrideOption[] = [
    {value: 'RED', label: 'RED (training)'},
    {value: 'WHITE', label: 'WHITE (white listed)'}
];

const MURPHY_OVERRIDER_TITLES: ComplianceOverrideOption[] = [
    {value: 'HSE', label: 'HSE'},
    {value: 'Houston Manager', label: 'Houston Manager'},
    {value: 'SuperIntendent', label: 'SuperIntendent'}
];

const MURPHY_TRAINING_OVERRIDES: ComplianceOverrideOption[] = [
    {value: 'RED_DISA', label: 'RED (DISA)'},
    {value: 'RED_COMPANY_GRADE', label: 'RED (Company Grade)'},
    {value: 'RED_OTHER', label: 'RED (Other)'}
];

export function getComplianceOverrideFieldConfiguration(
    customerID?: string
): ComplianceOverrideFieldConfiguration {
    if (isMurphyCustomer(customerID)) {
        return {
            overriderTitles: MURPHY_OVERRIDER_TITLES,
            trainingOverrides: MURPHY_TRAINING_OVERRIDES,
            trainingOverrideLabel: 'Training or Whitelist Override'
        };
    }

    return {
        overriderTitles: DEFAULT_OVERRIDER_TITLES,
        trainingOverrides: DEFAULT_TRAINING_OVERRIDES,
        trainingOverrideLabel: 'Training or Whitelist Override'
    };
}

const TRAINING_OVERRIDE_LABELS = [
    ...DEFAULT_TRAINING_OVERRIDES,
    ...MURPHY_TRAINING_OVERRIDES
].reduce<Record<string, string>>((labels, option) => {
    labels[option.value] = option.label;
    return labels;
}, {});

export function getTrainingOverrideDisplayLabel(value?: string): string {
    if (!value) return '';
    return TRAINING_OVERRIDE_LABELS[value] || value;
}
